<template>
  <section
    class="naj-box"
    :class="{ 'margin-bottom': !noBottomMargin }"
  >
    <header
      v-if="!noHeader"
      class="naj-box-header"
      :class="`${ disableCollapsing?'':'pointer '} ${headerClass || 'sub-header'}`"
      @click.self="headerClickHandler"
    >
      <div @click.self="headerClickHandler">
        <div class="header-slot">
          <slot name="header" />
        </div>

        <h5
          class="d-inline-block custom-header"
          style="text-align: center;"
        >
          <v-icon
            v-if="computedHeaderIcon"
            :class="[
              'header-icon',
              {
                'close-modal-button': insideModal,
              },
            ]"
            @click.self="headerClickHandler"
          >
            {{ computedHeaderIcon }}
          </v-icon>
          {{ title }}
        </h5>
      </div>
    </header>

    <div
      v-show="!isCollapsed || disableCollapsing"
      class="naj-box-content"
      :class="{ 'no-gutters': noGutters }"
    >
      <slot />
    </div>

    <footer
      v-if="hasFooter || !!this.$slots.footer"
      v-show="!isCollapsed || disableCollapsing"
      class="naj-box-footer"
    >
      <slot name="footer" />
    </footer>
    <span class="v-messages error--text error-message">{{ errorMessage }}</span>
  </section>
</template>

<script>
export default {
  name: 'NajBox',
  inject: {
    $validator: { default: {} },
    formContext: { default: {} },
  },
  props: {
    noHeader: { type: Boolean },
    title: { type: String },
    errorMessage: {
      type: String,
      required: false,
    },
    headerClass: { type: String },
    headerIcon: { type: String },
    collapsed: { type: Boolean },
    noGutters: { type: Boolean },
    noBottomMargin: { type: Boolean },
    insideModal: { type: Boolean },
    hasFooter: { type: Boolean },
    disableCollapsing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { isCollapsed: false };
  },
  computed: {
    computedHeaderIcon() {
      return !this.disableCollapsing
        ? this.isCollapsed
          ? 'mdi-chevron-down'
          : 'mdi-chevron-up'
        : this.headerIcon;
    },
  },
  watch: {
    formContext: {
      deep: true,
      handler(form) {
        if (form.isSubmitted && this.isRequired) {
          this.$validator.validateScopes()
            .then((valid) => {
              if (!valid) {
                this.isCollapsed = false;
              }
            });
        }
      },
    },
    collapsed(collapsed) {
      this.isCollapsed = collapsed;
    },
  },
  mounted() {
    this.isCollapsed = this.collapsed;
  },
  methods: {
    headerClickHandler() {
      if (!this.disableCollapsing) {
        this.isCollapsed = !this.isCollapsed;
      } else {
        this.$emit('iconClick');
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.naj-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 5px 0 12px 0 rgba(228, 230, 238, 0.6);

  div:not(.modal-content) > .naj-box {
    border-top: initial;
    box-shadow: none;
  }
  .header-slot {
    float: inline-end;
  }
  .header-icon {
    margin-left: 6px;
  }

  &.margin-bottom {
    margin-bottom: 25px;
  }

  ::v-deep .naj-box-header {
    position: relative;
    min-height: 30px;
    display: flex;
    align-items: center;
    font-weight: 500;
    &.pointer {
      cursor: pointer;
    }
  }

  .naj-box-footer {
    min-height: 30px;
    border-top: 2px solid #f4f5f8;
    padding: 20px;
    display: flex;
    align-items: center;
    color: #d8d8d8;
    font-size: 22px;
    justify-content: space-between;
    background-color: rgba(216, 216, 216, 0.1);
  }

  .naj-box-content {
    padding: 20px;

    &.no-gutters {
      padding: 0;
    }
  }
}

h5.custom-header {
  line-height: normal;
  .v-icon.v-icon {
    vertical-align: baseline;
  }
}

.main-header {
  background-color: #203f39;
  padding: 1.005rem 1.5rem;
  border-bottom: 2px solid #f4f5f8;
  line-height: 1.5;
  & > div {
    color: white;
    button {
      color: white;
    }
    h5.custom-header {
      font-size: 18px;
      .v-icon.v-icon {
        font-size: 18px;
      }
    }
  }
}

.sub-header {
  justify-content: center;
  text-align: center;
  background-color: #f7f7f7;
  border-radius: 5px;
  color: #203f39;
  padding: 10px;
  margin-bottom: 15px;
  margin-top: 24px;
  border: 1px solid #b69a70;
  border-top: none;
  line-height: normal;
  & > div {
    color: #34675a;
    width: 100%;
    button {
      color: #34675a;
    }
    h5.custom-header {
      font-size: 15px;
      .v-icon.v-icon {
        font-size: 15px;
      }
    }
  }
}
</style>
